"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateBookingPageByPlan = void 0;
const lodash_1 = require("lodash");
const detectPagePaidFunctions_1 = require("./detectPagePaidFunctions");
const userPlanAvailability_1 = require("./userPlanAvailability");
/**
 * ユーザーの現在のプランでページの機能が利用可能かバリデーションをかける
 * @param plan
 * @param publicPageParams
 * @returns
 */
const validateBookingPageByPlan = (ownerUid, plan, publicPageParams, publicBookingViewSetting, publicProfile) => {
    // チームプランの時点で全ての機能が利用できる。
    if (plan === 'team') {
        return { valid: true, unavailableFunctions: [] };
    }
    // 使用されている有料機能を取得
    const functionKeys = (0, detectPagePaidFunctions_1.detectPagePaidFunctions)(ownerUid, publicPageParams, publicBookingViewSetting, publicProfile);
    // 使用できない機能を抽出
    const unavailableFunctions = functionKeys.filter((key) => !(0, userPlanAvailability_1.isAvailable)(plan, key));
    return {
        valid: (0, lodash_1.isEmpty)(unavailableFunctions),
        unavailableFunctions
    };
};
exports.validateBookingPageByPlan = validateBookingPageByPlan;
//# sourceMappingURL=validateBookingPageByPlan.js.map